var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "#00274C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9974 26.2938H0.0078125L3.25651 23.0451V13.299C3.25884 10.9975 4.07558 8.77106 5.56208 7.01401C7.04859 5.25697 9.10893 4.08267 11.3782 3.69909V1.92855C11.3782 1.49774 11.5494 1.08458 11.854 0.77996C12.1586 0.475335 12.5718 0.304199 13.0026 0.304199C13.4334 0.304199 13.8466 0.475335 14.1512 0.77996C14.4558 1.08458 14.6269 1.49774 14.6269 1.92855V3.69909C15.3535 3.83354 16.7386 4.34882 16.7386 4.34882L18.5 5.5C18.5 5.5 19.9057 6.11501 20.5 7C21 7 22 9.5 22 9.5C22 9.5 23 11.5 22.7487 13.299V23.0451L25.9974 26.2938ZM13.0026 30.6957C13.8642 30.6957 14.6905 30.3535 15.2998 29.7442C15.909 29.135 16.2513 28.3087 16.2513 27.4471H9.7539C9.7539 28.3087 10.0962 29.135 10.7054 29.7442C11.3147 30.3535 12.141 30.6957 13.0026 30.6957Z",
    fill: "#00274C."
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBell);
export default __webpack_public_path__ + "static/media/emptyBell.ce0a93654c2ad579f14445347c9e9ca7.svg";
export { ForwardRef as ReactComponent };